export default {
	editGuide: "Modifier la relation",
	assignGuide: "Attribuer un guide",
	tabs: {
		link: "Existant",
		createNew: "Créer nouveau",
	},
	filters: {
		active: "Actif",
	},
};
